export default __webpack_public_path__ + "static/media/cv.8e60885b.pdf";